import type { TersaImageModel } from '../types';
import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const lumaModels: Record<string, TersaImageModel> = {
    'uni-v1': {
        chef: providers.luma,
        providers: [
            {
                ...providers.luma,
                model: undefined,
                model_create: wavespeed.image('luma/uni-v1/text-to-image'),
                model_edit: wavespeed.image('luma/uni-v1/edit'),
                getCost: ({ mode } = {}) => {
                    if (mode === 'i2i') return 0.069 * COST_FACTOR;
                    return 0.042 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '3x1', '1x3', '3x2', '2x3', '2x1', '1x2', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 4, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};